import { render, staticRenderFns } from "./terms-of-use.vue?vue&type=template&id=1362012e&scoped=true&"
import script from "./terms-of-use.vue?vue&type=script&lang=js&"
export * from "./terms-of-use.vue?vue&type=script&lang=js&"
import style0 from "./terms-of-use.vue?vue&type=style&index=0&id=1362012e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1362012e",
  null
  
)

export default component.exports